import type { CSSProperties } from "react"

export type EncumbranceLevel = "light" | "heavy" | "overloaded"

export const ENCUMBRANCE_COLORS: Record<EncumbranceLevel, string> = {
  light: "#3FBA34",
  heavy: "#FFD180",
  overloaded: "#FF4741"
}

export const getEncumbranceLevel = (
  loadRatio: number | null
): EncumbranceLevel | null => {
  if (loadRatio === null) {
    return null
  }
  if (loadRatio < 0.5) {
    return "light"
  }
  if (loadRatio <= 1) {
    return "heavy"
  }
  return "overloaded"
}

export const getEncumbranceFill = (loadRatio: number | null): number => {
  if (loadRatio === null) {
    return 0
  }
  return Math.max(0, Math.min(1, loadRatio))
}

export const getEncumbranceStyle = (
  loadRatio: number | null
): CSSProperties | undefined => {
  const level = getEncumbranceLevel(loadRatio)
  return level
    ? ({ "--encumbrance-color": ENCUMBRANCE_COLORS[level] } as CSSProperties)
    : undefined
}
